var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hour-glass"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2724 19.2019C20.1296 19.2019 21.6346 17.6955 21.6346 15.8372V5.73974C21.6346 3.88309 20.1293 2.375 18.2724 2.375H11.5353C9.6781 2.375 8.17308 3.88144 8.17308 5.73974V7.42308H6.49038C4.63552 7.42308 3.125 8.92952 3.125 10.7878V20.8853C3.125 22.7419 4.63031 24.25 6.48719 24.25H13.2243C15.0815 24.25 16.5865 22.7418 16.5865 20.8814V19.2019H18.2724ZM4.80769 11.2091C4.80769 10.0475 5.74845 9.10577 6.91189 9.10577H12.7996C13.9618 9.10577 14.9038 10.047 14.9038 11.2091V20.4639C14.9038 21.6256 13.9631 22.5673 12.7996 22.5673H6.91189C5.74977 22.5673 4.80769 21.6261 4.80769 20.4639V11.2091ZM9.85577 6.16036C9.85577 4.99909 10.7965 4.05769 11.96 4.05769H17.8477C19.0098 4.05769 19.9519 4.99893 19.9519 6.16106V15.4159C19.9519 16.5775 19.0142 17.5192 17.8487 17.5192H16.5857V10.785C16.5857 8.92824 15.0754 7.42308 13.2207 7.42308H9.85577V6.16036Z",
    fill: "#9098A2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.0961eb910ec05c4a7de2c53f4cbdfa84.svg";
export { ForwardRef as ReactComponent };